<template>
  <div class="pb-5 d-flex">
    <DashboardInfoDialog ref="dashboardInfoDialog"></DashboardInfoDialog>
    <span class="display-1 pt-1 font-weight-bold">{{
      $t("dashboard.general.Dashboard")
    }}</span>
    <span>
      <v-btn
        :title="$t('dashboard.general.Click to see more information')"
        @click.stop="$refs.dashboardInfoDialog.openDialog()"
        icon
        large
      >
        <v-icon color="primary">far fa-question-circle</v-icon>
      </v-btn>
    </span>
  </div>
</template>

<script>
import messages from "./modules/lang/main/export";
import DashboardInfoDialog from "@/components/informational_dialogs/private/dashboard_info_dialog.vue";
export default {
  components: {
    DashboardInfoDialog
  },
  i18n: { messages },
  data() {
    return {
      dashboardInfoDialog: false
    };
  },
  mounted() {}
};
</script>
